export const products = [
  {
    slug: "minex-prime",
    name: "MINEX PRIME",
    category: "Emulsion explosives",
    type: "Cap sensitive emulsion explosive",
    description:
      "Cap-sensitive packaged emulsion explosive for mining projects.",
    tags: ["Mining"],
    models: [],
    image: "/brand/minex-prime-2026.png",
    preview: "/brand/minex-prime-2026.webp",
    width: 1299,
    height: 1211,
    alt: "MINEX PRIME packaged emulsion cartridges shown in the Nitro-Detex product artwork",
  },
  {
    slug: "novex-anfo",
    name: "NOVEX ANFO",
    category: "Blasting agents",
    type: "Ammonium nitrate fuel oil blasting agent",
    description:
      "ANFO for mining and quarrying projects.",
    tags: ["Mining", "Quarrying"],
    models: [],
    image: "/brand/novex-anfo-2026.png",
    preview: "/brand/novex-anfo-2026.webp",
    width: 1374,
    height: 1145,
    alt: "NOVEX ANFO bag and product presentation at a mining site",
  },
  {
    slug: "novex-tronic",
    name: "NOVEX TRONIC",
    category: "Electronic initiation",
    type: "Electronic detonator system",
    description:
      "Electronic detonator system for mining projects.",
    tags: ["Mining"],
    models: [],
    image: "/brand/novex-tronic-2026.png",
    preview: "/brand/novex-tronic-2026.webp",
    width: 1374,
    height: 1145,
    alt: "NOVEX TRONIC electronic detonator system and yellow control case",
  },
  {
    slug: "novex-det",
    name: "NOVEX DET",
    category: "Non-electric initiation",
    type: "Non-electric detonator range",
    description:
      "Non-electric detonator range with LP, MS, SD and SDC models.",
    tags: [],
    models: ["LP", "MS", "SD", "SDC"],
    image: "/brand/novex-det-2026.png",
    preview: "/brand/novex-det-2026.webp",
    width: 1536,
    height: 1024,
    alt: "NOVEX DET non-electric detonator range showing LP, MS, SD and SDC models",
  },
] as const;
